import React from 'react';
import ContainerComponent from '../../helpers/components/container.component';
import PageHeaderComponent from '../../helpers/components/page_header.component';
import CreateBilling from './components/create_billing';

const PurchaseCreate = () => {
    return (
        <>
            <ContainerComponent span={22} top={20}>
                <PageHeaderComponent />
                <CreateBilling />
            </ContainerComponent>
        </>
    );
}

export default PurchaseCreate;